<template>
    <NuxtLayout name="main" :dark="true" :favorite="true">
        <!-- * 模型介绍 -->
        <ui-modal ref="info" height="auto" spacing="32px 56px 40px">
            <div class="text-emphas text-[30px] leading-[46px] font-bold">{{ $t("ModelIntroduction") }}</div>
            <div class="mt-[16px]">
                <p>{{ $t("AASymbolConversionIntroduction") }}</p>
            </div>
        </ui-modal>

        <div :class="css.container" class="container">
            <!-- * 标题区域 -->
            <h1 :class="css.title" class="color-1 font-bold font-variable">{{ $t("AAAbbreviationConverter") }}</h1>
            <!-- * 控制器区域 -->
            <div :class="css.control">
                <!-- * 模型顶部 -->
                <div class="flex items-center justify-between">
                    <!-- * 状态选择器 -->
                    <ui-radio-group :class="[css.radios, css_normalize.radio]" v-model="mode" @change="methods.mode">
                        <ui-radio :class="css.radio" value="more">
                            <span class="font-bold color-1">{{ $t("OneLetterAA") }}</span>
                            <img src="https://rdgta.cdn.cyagen.com/rddc/images/bio/arrow.webp" alt="" />
                            <span class="font-bold color-1">{{ $t("ThreeLetterAA") }}</span>
                        </ui-radio>
                        <ui-radio :class="css.radio" value="single">
                            <span class="font-bold color-1">{{ $t("ThreeLetterAA") }}</span>
                            <img src="https://rdgta.cdn.cyagen.com/rddc/images/bio/arrow.webp" alt="" />
                            <span class="font-bold color-1">{{ $t("OneLetterAA") }}</span>
                        </ui-radio>
                    </ui-radio-group>

                    <!-- * 模型介绍 -->
                    <div class="flex items-center justify-center">
                        <h2 class="font-normal transition duration-200 cursor-pointer underline underline-offset-2 hover:text-main" @click="info?.openModal()">
                            {{ $t("ModelIntroduction") }}
                        </h2>
                        <div class="w-[1px] h-[12px] mx-[16px] bg-emphas"></div>
                        <h2 class="font-normal transition duration-200 cursor-pointer underline underline-offset-2 hover:text-main" @click="methods.next">
                            {{ $t("VideoTutorial") }}
                        </h2>
                    </div>
                </div>

                <!-- * 序列输入框 -->
                <ui-textarea
                    :class="css.input"
                    :maxlength="10000"
                    v-model="sequence"
                    :placeholder="mode == 'more' ? $t('AASymbolConversionPlaceholder1') : $t('AASymbolConversionPlaceholder2')"
                    @input="methods.handle"
                    @compositionstart="composing = true"
                    @compositionend="methods.handleEnd" />

                <!-- * 控制按钮 -->
                <div :class="css.buttons">
                    <ui-button size="middle" :width="112" :class="css_button.cancel" @click="methods.reset">{{ $t("Reset") }}</ui-button>
                    <ui-button size="middle" :width="112" @click="methods.analyze">{{ $t("Convert") }}</ui-button>
                </div>
            </div>

            <!-- * 输出区域 -->
            <div :class="css.result" v-show="result.length">
                <div :class="css.header">
                    <div :class="css.name" class="color-1 font-bold font-variable">{{ $t("ConversionResults") }}</div>
                    <div :class="css.copy" @click="methods.copy">{{ $t("Copy") }}</div>
                </div>

                <div :class="css.context">
                    <template v-for="(value, key) in result">
                        <template v-if="key != 0">-</template>
                        <span :class="css[value.status]">{{ value.context }}</span>
                    </template>
                </div>
            </div>
        </div>
    </NuxtLayout>
</template>

<script lang="ts" setup>
//* 组件库
import { UiRadioGroup, UiTextarea, UiButton, UiModal, UiRadio } from "various-ui";
//* 组件属性
import { useComposable } from "./src/composable";
//* 样式
import css from "./style/index.module.less";
import css_button from "@/assets/style/src/button.module.less";
import css_normalize from "@/assets/style/src/index.module.less";

//* 组合函数
const { refs, nodes, methods } = useComposable();
const { mode, result, sequence, composing } = refs;
const { info } = nodes;
</script>
